module.exports = __webpack_public_path__ + "static/media/ES-Ua.2f89e327.png";